<template>
	<card class="job-factor-assignation">
		<div class="tw-p-6">
			<div class="tw-flex tw-flex-wrap tw--mx-6">
				<div class="tw-w-1/2 tw-px-6 tw-mb-4" v-for="(factor, index) in selectedJob.factors" :key="factor.name">
					<job-factor-assignation-factor
						:factor="factor"
						:index="index"
						@factorChange="onFactorChange"
					/>
				</div>
			</div>
		</div>
	</card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/p-card';
import JobFactorAssignationFactor
	from '@/modules/polls/components/custom/JobEvaluationPollPage/JobFactorAssignationFactor';
import { update } from 'ramda';

export default {
	name: 'JobFactorAssignation',
	components: { JobFactorAssignationFactor, Card },
	props: ['selectedJob'],
	methods: {
		onFactorChange({ factor, index }) {
			this.$emit('jobChange', {
				...this.selectedJob,
				factors: update(index, factor, this.selectedJob.factors),
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.job-factor-assignation {
	min-height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/modules/polls/components/custom/JobEvaluationPollPage/JobFactorAssignation.vue